import { SORT_ORDER, TableSortOption } from '@evinced-private/ui-common';

import {
	MFA_SESSIONS_TABLE_ID,
	WFA_SESSIONS_TABLE_ID
} from 'src/common/pages/dashboards-container/dashboard_consts';

export const TABLE_STATE_DEFAULT_SORT: { [key: string]: TableSortOption[] } = {
	[WFA_SESSIONS_TABLE_ID]: [
		{
			dataField: 'runTime',
			order: SORT_ORDER.DESC
		}
	],
	[MFA_SESSIONS_TABLE_ID]: [
		{
			dataField: 'lastModified',
			order: SORT_ORDER.DESC
		}
	]
};
